'use client';
import { GlueErrorResponse } from '@/src/lib/glue/types';
import { getErrorMessageFromAnyErrorLike } from '@/src/lib/utils/error';
import { useNotification } from '@/src/app/components/Providers/context/NotificationProvider';
import { NotificationItem, NotificationMode, NotificationType } from '@/src/app/components/Notification/types';
import { ReactNode } from 'react';

export function useNotify() {
  const { showNotification, removeNotification } = useNotification();

  function toastNotification(
    message: string | ReactNode | GlueErrorResponse | Error | unknown,
    type: NotificationType = NotificationType.SUCCESS,
    autoClose?: boolean,
    autoCloseDuration?: number,
  ): NotificationItem | undefined  {
    const processedMessage: string | ReactNode = getErrorMessageFromAnyErrorLike(message);

    return showNotification(processedMessage, type, NotificationMode.TOAST, undefined, autoClose, autoCloseDuration);
  }

  function flashNotification(
    message: string | GlueErrorResponse | Error | unknown,
    type: NotificationType = NotificationType.SUCCESS,
    options?: {
      description?: string;
      autoClose?: boolean;
      autoCloseDuration?: number;
      isClosable?: boolean;
      id?: string;
    },
  ) {
    const processedMessage: string | ReactNode = getErrorMessageFromAnyErrorLike(message);

    return showNotification(
      processedMessage,
      type,
      NotificationMode.FLASH,
      options?.description,
      options?.autoClose,
      options?.autoCloseDuration,
      options?.isClosable,
      options?.id,
    );
  }

  function dismissNotification(id: string) {
    removeNotification(id);
  }

  return {
    toastNotification,
    flashNotification,
    dismissNotification,
  };
}
